import type { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';

import TermsAndConditionsPage from '@components/terms-and-conditions-page/terms-and-conditions-page';
import { MetaTags } from '@helpers/meta-tags.helper';
import MainLayout from '@layouts/main-layout/main-layout';
import { IUBENDA_TERMS_AND_CONDITIONS_URL } from '@libs/legal-documents';
import { getTermsAndConditionsHtml } from '@services/legal.service';

interface TermsAndConditionsProps {
  contentHtml: string | null;
  hostedDocumentUrl?: string;
}

const TermsAndConditions: NextPage<TermsAndConditionsProps> = ({
  contentHtml,
  hostedDocumentUrl,
}: TermsAndConditionsProps) => {
  return (
    <>
      <Head>
        {MetaTags({
          title: 'Terms & Conditions | Agilie',
          description:
            'Read Agilie’s Terms and Conditions. Learn about the rules for using our website, intellectual property rights, and how we ensure a fair partnership with you.',
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <MainLayout>
        <TermsAndConditionsPage contentHtml={contentHtml} hostedDocumentUrl={hostedDocumentUrl} />
      </MainLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps<TermsAndConditionsProps> = async ({ res }) => {
  try {
    const contentHtml = await getTermsAndConditionsHtml();
    return {
      props: {
        contentHtml,
      },
    };
  } catch (error) {
    return {
      props: {
        contentHtml: null,
        hostedDocumentUrl: IUBENDA_TERMS_AND_CONDITIONS_URL,
      },
    };
  }
};

export default TermsAndConditions;
